import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import docSheet from "../../assets/Images/TempleDetail/doc-sheet.png";
import arrowUpRight from "../../assets/Images/TempleDetail/arrow-up-right.svg";
import verifiedCheck from "../../assets/Images/TempleDetail/verified-check.svg";
import { T, FONT, SectionCard, SectionHeading } from "./shared";
import DocumentModal from "./DocumentModal";

const isImage = (url) => /\.(png|jpe?g|webp|gif|avif)(\?|$)/i.test(String(url || ""));

// Figma 3472:6064 "Documents — Preview Cards". Campaign documents are files without titles,
// so each card is numbered; images show as the page preview, other files as a paper sheet.
const TempleDocuments = ({ documents = [] }) => {
  const [openDoc, setOpenDoc] = useState(null);
  const docs = documents.filter((d) => d?.url);
  if (!docs.length) return null;

  return (
    <SectionCard id="documents" sx={{ display: "flex", flexDirection: "column", gap: "22px" }}>
      <SectionHeading eyebrow="Documents" hindi="॥ प्रमाण ॥" title="Verified documents" />
      <Box
        sx={{
          display: "flex",
          gap: "16px",
          overflowX: "auto",
          pb: "4px",
          mx: { xs: "-20px", sm: 0 },
          px: { xs: "20px", sm: 0 },
          scrollSnapType: "x mandatory",
          scrollbarWidth: "thin",
        }}
      >
        {docs.map((doc, i) => {
          const title = doc.title || doc.name || `Verified document ${i + 1}`;
          return (
            <Box
              key={doc.id ?? i}
              component="button"
              type="button"
              onClick={() => setOpenDoc({ ...doc, displayTitle: doc.title || doc.name || `Verified document ${i + 1}` })}
              sx={{
                flex: "0 0 240px",
                scrollSnapAlign: "start",
                border: `1px solid ${T.sand}`,
                borderRadius: "18px",
                overflow: "hidden",
                background: "#FFFFFF",
                textDecoration: "none",
                p: 0, textAlign: "left", cursor: "pointer", font: "inherit",
                display: "flex",
                flexDirection: "column",
                transition: "transform 0.2s, box-shadow 0.2s",
                "&:hover": { transform: "translateY(-3px)", boxShadow: "0px 12px 24px rgba(77,38,13,0.1)" },
                "&:hover .doc-sheet": { transform: "rotate(-1.5deg)" },
                "&:focus-visible": { outline: `2px solid ${T.gold}`, outlineOffset: "2px" },
              }}
            >
              <Box sx={{ position: "relative", height: "200px", background: T.cream, overflow: "hidden" }}>
                <Box sx={{ position: "absolute", left: "48px", top: "33px", width: "150px", height: "184px", borderRadius: "4px", border: `1px solid ${T.sand}`, background: "#FFFFFF", transform: "rotate(4deg)" }} />
                <Box
                  className="doc-sheet"
                  component="img"
                  src={isImage(doc.url) ? doc.url : docSheet}
                  alt=""
                  loading="lazy"
                  sx={{
                    position: "absolute",
                    left: "45px",
                    top: "26px",
                    width: "150px",
                    height: "184px",
                    objectFit: "cover",
                    objectPosition: "top",
                    borderRadius: "4px",
                    border: "1px solid #F0E3D4",
                    boxShadow: "0px 6px 14px 0px rgba(77,38,13,0.14)",
                    background: "#FFFFFF",
                    transition: "transform 0.25s",
                  }}
                />
              </Box>
              <Box sx={{ borderTop: `1px solid ${T.sand}`, px: "16px", pt: "16px", pb: "18px", display: "flex", flexDirection: "column", gap: "4px" }}>
                <Typography sx={{ fontFamily: FONT, fontWeight: 700, fontSize: "15px", lineHeight: "20px", color: T.ink }}>{title}</Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: "6px", pt: "8px" }}>
                  <Typography sx={{ fontFamily: FONT, fontWeight: 700, fontSize: "13px", lineHeight: "18px", color: T.red }}>View document</Typography>
                  <Box component="img" src={arrowUpRight} alt="" sx={{ width: "14px", height: "14px" }} />
                </Box>
              </Box>
            </Box>
          );
        })}
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <Box component="img" src={verifiedCheck} alt="" sx={{ width: "16px", height: "16px" }} />
        <Typography sx={{ fontFamily: FONT, fontWeight: 500, fontSize: "13px", lineHeight: "18px", color: T.muted }}>
          All documents reviewed by Truehope's verification team
        </Typography>
      </Box>
      <DocumentModal doc={openDoc} onClose={() => setOpenDoc(null)} />
    </SectionCard>
  );
};

export default TempleDocuments;
